<!--
 * @Author: 张天昊
 * @Date: 2024-05-21 16:49:50
 * @LastEditTime: 2024-06-05 10:27:24
 * @LastEditors: 张天昊
 * @Description: 车辆面板
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/VehiclePanel.vue
-->
<script>
import { defineComponent, computed } from 'vue';
import { AuxiliaryInfoTypes, dateStrFormat2 } from '../constants';
import { useAuxiliaryInfoCardScroll } from '../composables/useAuxiliaryInfoCardScroll';
import { usePanelMinHeight } from '../composables/usePanelMinHeight';
import VehicleCard from './VehicleCard.vue';
import DataEmpty from './DataEmpty.vue';
import store from '@/store';
import moment from 'moment';

export default defineComponent({
  name: 'VehiclePanel',
  components: {
    VehicleCard,
    DataEmpty
  },
  setup(_, { expose }) {
    const detailInfo = computed(
      () => store.state.itineraryUniversal.detailInfo.value
    );
    const datas = computed(() =>
      detailInfo.value ? detailInfo.value.itineraryCarMessage : []
    );
    const { cards, anchorTo } = useAuxiliaryInfoCardScroll(
      AuxiliaryInfoTypes.车辆
    );
    function dateFormat(start, end) {
      return `${moment(start).format(dateStrFormat2)} 至
      ${moment(end).format(dateStrFormat2)}`;
    }
    const { panelMinHeight } = usePanelMinHeight();
    expose({
      anchorTo
    });
    return {
      cards,
      datas,
      dateFormat,
      panelMinHeight
    };
  }
});
</script>

<template>
  <div class="px-12 pt-16" :style="{ minHeight: panelMinHeight }">
    <!-- 块 -->
    <template v-if="datas.length">
      <div
        v-for="data in datas"
        :key="data.id"
        class="[&:not(:first-child)]:mt-20"
      >
        <div class="text-14 leading-20 font-semibold flex items-center">
          <svg-icon
            pre-path="itineraryUniversal"
            name="ic-time"
            class="w-14 h-14 mr-6"
          />{{ dateFormat(data.teamStartDate, data.teamEndDate) }}
        </div>
        <VehicleCard class="mt-12" ref="cards" :data="data" />
      </div>
    </template>
    <DataEmpty v-else />
  </div>
</template>
